// @flow
import {Tag, findMarkdocTag, filterMarkdocTags} from 'docs/util';

import type {MarkdocTagRegistration} from 'docs/markdoc';

const Heading = (tag) => tag.name === 'Heading';
const Paragraph = (tag) => tag.name === 'Paragraph';

export const Step: MarkdocTagRegistration = {
  tag: 'step',
  component: 'Step',
  attributes: {
    id: {
      type: String,
      required: true,
    },
    when: {
      type: Object,
      required: false,
    },
    unless: {
      type: Object,
      required: false,
    },
    label: {
      type: String,
      required: false,
      matches: ['client', 'server', 'none'],
    },
    toggle: {
      type: String,
      required: false,
    },
    toggleDefaultOn: {
      type: Boolean,
      description:
        'When set to true on a Step with a toggle defined, the toggle switch on this step will default to on and show the content for that toggle on page load.',
      required: false,
    },
  },
  render(node, config) {
    const attributes = node.renderAttributes(this.attributes, config);
    const children = node.renderChildren(config);

    const heading = findMarkdocTag(children, Heading)?.children?.[0];
    const paragraphs = filterMarkdocTags(children, Paragraph);

    // Remainder consists of any custom components we want embedded at the bottom of a Step
    const remainder = filterMarkdocTags(
      children,
      (tag) => tag.name !== 'Paragraph' && tag.name !== 'Heading',
    );

    return new Tag(
      this.tag,
      {...attributes, heading, paragraphs, remainder},
      children,
    );
  },
};
